export default __webpack_public_path__ + "static/logo-vodafone-5008daafa10fd5b2c7cda6fa42919604.png";